import { IPaymentTokenAccount } from '@monofront/types';
import Paypal from '@monofront/design-system/visuals/Icons/Old/Paypal';
import { useTranslations } from 'next-intl';

interface IPaypalRowProps {
  paymentMethod: IPaymentTokenAccount;
  tags?: React.ReactElement<any>[];
}

const PaypalRow: React.FC<IPaypalRowProps> = ({ paymentMethod, tags }) => {
  const tAccount = useTranslations('Account');

  return (
    <>
      <Paypal width={30} />
      <div className="paypal-account">
        <div className="label-container">
          <p className="label">{tAccount('paypalAccount')}</p>
          {tags && tags.map((Tag) => Tag)}
        </div>
        <p className="email" title={paymentMethod.email}>
          {paymentMethod.email}
        </p>
      </div>
      <style jsx>
        {`
          .paypal-account {
            margin-left: var(--space-4);
          }

          .email {
            color: var(--clr-grey-1);
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: calc(100vw - 130px);
            overflow: hidden;
            font-weight: 400;
          }

          .label-container {
            display: flex;
            align-items: center;
          }

          .label {
            margin-right: var(--space-2);
          }
        `}
      </style>
    </>
  );
};

export default PaypalRow;
